import PropTypes from 'prop-types';
import React from 'react';

import { propTypesGatsbyImage } from '../../../shared/constants/Proptypes';

import Card from '../../../ui/Atoms/Card';
import Input from '../../../ui/Atoms/Input';
import Picture from '../../../ui/Atoms/Picture';
import Button from '../../Atoms/Button';
import Checkbox from '../../Atoms/Checkbox';

import { Color } from '../../../shared/constants/Colors';
import * as S from './NewsletterCard.styles';

export const NewsletterCard = ({
  contentColor,
  description,
  didConsent,
  imageAlt,
  imageProps,
  label,
  onAccept,
  onChange,
  onClick,
  optinLabel,
  placeholder,
  title,
  value,
}) => {
  if (
    !title ||
    !description ||
    !imageProps ||
    !placeholder ||
    !label ||
    !onChange
  ) {
    return null;
  }
  const cardTitle = title.substring(0, 40);
  const cardDescription = description.substring(0, 110);

  return (
    <Card isStatic={true}>
      <S.NewsletterCard>
        <Picture
          altText={imageAlt || 'newsletter-picture'}
          width='100%'
          {...imageProps}
        />
        <S.Title contentColor={contentColor}>{cardTitle}</S.Title>
        <S.Description contentColor={contentColor}>
          {cardDescription}
        </S.Description>
        <Input
          appearance='primary'
          hasFocus={false}
          onChange={onChange}
          placeholder={placeholder}
          type='email'
          value={value ?? placeholder}
        />
        <S.CheckboxWrapper>
          <Checkbox
            isChecked={didConsent}
            text={optinLabel}
            onClick={onAccept}
            isRequired={true}
            isNegative={true}
          />
        </S.CheckboxWrapper>
        <Button isDisabled={!didConsent} onClick={onClick}>
          {label}
        </Button>
      </S.NewsletterCard>
    </Card>
  );
};

NewsletterCard.propTypes = {
  /**
   * Changes color of card title and description. Set to white by default.
   */
  contentColor: PropTypes.string,
  /**
   * Short text. limited to 110 characters.
   */
  description: PropTypes.string.isRequired,
  /**
   * Allow the user to submit or not.
   */
  didConsent: PropTypes.bool,
  /**
   * Set an optional alt to the illustration. Set 'newsletter-illustration by default.
   */
  imageAlt: PropTypes.string,
  /**
   * Picture url.
   */
  imageProps: PropTypes.shape({
    imageObject: PropTypes.shape(propTypesGatsbyImage),
    imageUrl: PropTypes.string,
  }).isRequired,
  /**
   * Button label.
   */
  label: PropTypes.string.isRequired,
  /**
   * Function updating the consent value.
   */
  onAccept: PropTypes.func.isRequired,
  /**
   * Function called every time the event is triggered.
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Function called every time the event is triggered
   */
  onClick: PropTypes.func,
  /**
   * Label of the consent checkbox
   */
  optinLabel: PropTypes.string,
  /**
   * Input placeholder.
   */
  placeholder: PropTypes.string.isRequired,
  /**
   * Card title.
   */
  title: PropTypes.string.isRequired,
  /**
   * Value of the input element.
   */
  value: PropTypes.string,
};

NewsletterCard.defaultProps = {
  contentColor: Color.WHITE,
  imageAlt: 'newsletter-illustration',
};

export default NewsletterCard;
